import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setSingleTestData } from "../../repository/slice";

function* getSingleTestDataWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/statistic/quiz/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleTestData(data));
        }
    } catch (error) {
        console.error("getSingleTestDataWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleTestDataWatcher() {
    yield takeLatest("@saga/GET_SINGLE_TEST_DATA", getSingleTestDataWorker);
};